// Features whose permission id is a single segment but whose routes go deeper, e.g.
// /benchmark/:id or /research/survey/:waveKey. Without this the permission lookup for a
// child URL resolves to "research/survey", which matches no permission, and a cold load of
// the child URL is bounced to the first allowed menu route.
const SINGLE_SEGMENT_ROUTES = new Set(['tasks', 'benchmark', 'research']);

export const extractFinalUrl = (url: string): string => {
  const urlWithoutQuery = url?.split('?')[0];
  // Only remove leading '/' if present, otherwise use the URL as-is
  const urlToProcess = urlWithoutQuery?.startsWith('/')
    ? urlWithoutQuery.slice(1)
    : urlWithoutQuery;
  const segments = urlToProcess?.split('/');
  const lastSegment = SINGLE_SEGMENT_ROUTES.has(segments[0]) ? 1 : 2;

  return segments
    .slice(0, lastSegment)
    .filter(segment => segment !== 'deal') // workaround for deal-book
    .join('/');
};
